import { useState, useCallback } from 'react';
import type { Property } from '../../types/property';

export function useDeletePropertyDialog(deleteProperty: (id: string) => Promise<void>) {
  const [state, setState] = useState<{
    isOpen: boolean;
    property: Property | null;
  }>({ isOpen: false, property: null });

  const openDialog = useCallback((property: Property) => {
    setState({ isOpen: true, property });
  }, []);

  const closeDialog = useCallback(() => {
    setState({ isOpen: false, property: null });
  }, []);

  const confirmDelete = useCallback(() => {
    if (state.property) {
      deleteProperty(state.property.id);
      setState({ isOpen: false, property: null });
    }
  }, [state.property, deleteProperty]);

  return {
    isOpen: state.isOpen,
    propertyAddress: state.property?.address || '',
    openDialog,
    closeDialog,
    setIsOpen: (open: boolean) => { if (!open) closeDialog(); },
    confirmDelete,
  };
}
